import createBuyerIntentView from './createBuyerIntentView'

const BuyerIntentCompareView = createBuyerIntentView({
  displayName: 'BuyerIntentCompareView',
  tag: 'comparisons.show',
})

export default BuyerIntentCompareView
